<template>
  <div class="properties-list container p-t-md p-l-md p-r-md">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h3 class="has-text-weight-bold is-size-4">{{ title }}</h3>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item" v-if="showButtonMap">
          <button
            class="button is-primary has-text-weight-bold"
            @click="handleMapVisible"
          >
            Cambiar a modo Mapa
          </button>
        </div>
        <div class="level-item">
          <div
            v-if="showMoreProperties"
            class="has-text-weight-bold has-text-link action"
            @click="handleOpenProperties"
          >
            Ver más propiedades
          </div>
        </div>
      </div>
    </div>
    <div v-show="hasProperties" class="columns is-multiline is-tablet">
      <router-link
        v-for="item in items"
        :key="item.id"
        :to="{ name: 'property-detail', params: { id: formatUrl(item) } }"
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        class="column is-half-tablet is-one-third-tablet is-one-quarter-desktop"
      >
        <div
          :class="[
            isActive && 'router-link-active',
            isExactActive && 'router-link-exact-active'
          ]"
        >
          <a :href="href" target="_blank">
            <property-item :property="item" />
          </a>
        </div>
      </router-link>
      <slot name="last-item"></slot>
    </div>
    <div
      v-show="!hasProperties"
      class="has-text-weight-bold has-text-centered m-lg"
    >
      No encontramos propiedades con estas caracteristicas.
      <span class="has-text-link action" @click="handleClearFilter">
        Ver todas las propiedades
      </span>
    </div>
  </div>
</template>

<script>
import PropertyItem from "@/components/PropertyItem";
import PropertyType from "@/constants/properties/ad-type";

export default {
  name: "PropertyList",

  components: {
    PropertyItem
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "Propiedades"
    },
    showMoreProperties: {
      type: Boolean,
      default: false
    },
    showButtonMap: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasProperties() {
      return this.items.length > 0;
    }
  },

  methods: {
    handleOpenProperties() {
      this.$emit("open-properties");
    },
    handleClearFilter() {
      this.$emit("clear-filter");
    },
    formatUrl(item) {
      let adTypeDesc = PropertyType.get[item.ad_type];
      let rooms = item.rooms;
      let roomType = "hab";
      if (rooms) {
        switch (item.use) {
          case "Local Comercial":
          case "Bodega":
            roomType = "esp";
            break;
          case "Oficina":
            roomType = "priv";
            break;
        }
      }
      let customUrl = `${adTypeDesc}-${item.use}`;
      if (rooms) {
        customUrl += `-${rooms}${roomType}`;
      }
      customUrl += `-${item.neighborhood}-${item.city}-${item.state}`;
      customUrl = customUrl
        .toLowerCase()
        .replaceAll(" ", "-")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let propertyIdUrl = `-I-${item.property_key}`;
      let encodedUrl = encodeURIComponent(customUrl + propertyIdUrl);
      return encodedUrl;
    },
    handleMapVisible() {
      this.$emit("show-map");
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  &:hover {
    cursor: pointer;
  }
}
</style>
